
import { Component, Vue, Prop } from "vue-property-decorator";
import { accountApi } from "../services/api/account/account";
import { UpdateSecretQuestionCommand } from "../services/api/models/UpdateSecretQuestionCommand.model";
import TransitionMessage from "./TransitionMessage.vue";

@Component({ components: { TransitionMessage } })
export default class SecretQuestion extends Vue {
  @Prop() readonly profile: any;

  private errorMessageShow = false;
  private errorMessage = "";
  private isSecretQuestionEditing = true;
  private profileSecretQuestion = "";
  private secretQuestion = "";
  private isSavingSecretQuestion = false;
  private secretAnswer = "";
  private confirmSecretAnswer = "";
  $t: any;

  async mounted() {
    await this.load();
  }

  async load() {
    let profile = this.profile;
    this.profileSecretQuestion = profile.secretQuestion ?? "";
    this.secretQuestion = profile.secretQuestion ?? "";
    this.isSecretQuestionEditing = this.profileSecretQuestion === "";
  }

  async saveSecretQuestion() {
    this.isSavingSecretQuestion = true;
    this.errorMessageShow = false;
    this.errorMessage = "";

    if (this.secretAnswer !== this.confirmSecretAnswer) {
      this.returnMessage(
        "Las <strong>respuestas</strong> ingresadas no coinciden."
      );
      return;
    }

    if (this.secretAnswer === "") {
      this.returnMessage("La <strong>respuesta</strong> no puede estar vacia.");
      return;
    }

    if (this.secretQuestion === "") {
      this.returnMessage("Seleccione una <strong>pregunta secreta</strong>.");
      return;
    }

    try {
      const data = new UpdateSecretQuestionCommand(
        this.secretQuestion,
        this.secretAnswer,
        this.confirmSecretAnswer
      );
      await accountApi.updateSecretQuestion(data);
      this.profileSecretQuestion = this.secretQuestion;
      this.isSecretQuestionEditing = false;
    } catch (error) {
      if (error?.response?.data) {
        this.errorMessageShow = true;
        this.errorMessage = this.$t(`errors.${error.response.data}`);
      }
    } finally {
      this.isSavingSecretQuestion = false;
    }
  }

  returnMessage(text: string) {
    this.isSavingSecretQuestion = false;
    this.errorMessageShow = true;
    this.errorMessage = text;
  }
}
